var BillingCommitment = /*#__PURE__*/function (BillingCommitment) {
  BillingCommitment["Yearly"] = "Yearly";
  BillingCommitment["AnnualBilledMonthly"] = "AnnualBilledMonthly";
  BillingCommitment["Monthly"] = "Monthly";
  return BillingCommitment;
}({});

export { BillingCommitment };
